// Video tutorial URLs for each page
// Product managers can easily update these URLs

export const pageVideos = {
  'wealth-dashboard': {
    title: 'Wealth Dashboard Overview',
    url: 'https://youtu.be/aJWzLCP0iZ0',
    description: 'Learn how to read and interpret your wealth dashboard'
  },
  'income-management': {
    title: 'Income Management Tutorial',
    url: 'https://youtu.be/rxGD1EKtLfA',
    description: 'Manage your income sources and projections'
  },
  'expense-tracking': {
    title: 'Expense Tracking Guide',
    url: 'https://youtu.be/FPbTMkEhLqE',
    description: 'Track and categorize your expenses effectively'
  },
  'asset-portfolio': {
    title: 'Asset Portfolio Management',
    url: 'https://youtu.be/8ehB_e6kKVQ',
    description: 'Manage your investment portfolio and asset allocation'
  },
  'debt-liabilities': {
    title: 'Debt Management Tutorial',
    url: 'https://youtu.be/40Fl7IY6WTg',
    description: 'Track and optimize your debt paydown strategy'
  },
  'setup': {
    title: 'Retirement Setup Guide',
    url: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ', // Replace with actual video URL
    description: 'Configure your retirement planning parameters'
  },
  'monte-carlo': {
    title: 'Monte Carlo Simulation Tutorial',
    url: 'https://youtu.be/m8j79p9W2PY',
    description: 'Learn how to use Monte Carlo simulation for retirement planning'
  },
  'investments-allocations': {
    title: 'Investments & Allocations Tutorial',
    url: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ', // Replace with actual video URL
    description: 'Learn how to track recurring investments and manage asset allocation'
  }
};

export const getVideoForPage = (pageName) => {
  return pageVideos[pageName] || null;
};
